// extracted by mini-css-extract-plugin
module.exports = {"friendlist":"FriendList_friendlist__1awj9"};